export const ModalModes = {
    ADD: "add",
    EDIT: "edit",
    CHANGE_ROLE: "change_role",
}